import api from "./api";

function toPortalErrorMessage(error, fallback = "Klantportaal laden mislukt") {
  const code = String(error?.response?.data?.code || "").trim().toUpperCase();
  const status = Number(error?.response?.status || 0);

  if (code === "CUSTOMER_PORTAL_DISABLED") {
    return "Klantportaal is nog niet ingeschakeld voor jouw organisatie.";
  }

  if (code === "CUSTOMER_PORTAL_SCOPE_INVALID") {
    return "Je account heeft nog geen geldige klantkoppeling. Neem contact op met Logboek24 support.";
  }

  if (code === "CUSTOMER_PORTAL_ACCOUNT_REQUIRED" || status === 403) {
    return "Je hebt geen toegang tot dit klantportaal.";
  }

  if (code === "CUSTOMER_PORTAL_WRITE_FORBIDDEN") {
    return "Je rol in het klantportaal heeft geen schrijftoegang.";
  }

  if (code === "CUSTOMER_PORTAL_REPLY_DISABLED") {
    return "Reageren is voor dit gesprek uitgeschakeld.";
  }

  return error?.response?.data?.message || fallback;
}

export async function getCustomerPortalDashboard() {
  const res = await api.get("/customer-portal/dashboard");
  return res?.data || {};
}

export async function getCustomerPortalWorkorders(query = {}) {
  const res = await api.get("/customer-portal/workorders", {
    params: query,
  });
  return res?.data || { items: [], page: 1, limit: 25, total: 0 };
}

export async function getCustomerPortalWorkorder(id) {
  const res = await api.get(`/customer-portal/workorders/${id}`);
  return res?.data || { item: null };
}

export async function getCustomerPortalInstallations(query = {}) {
  const res = await api.get("/customer-portal/installations", {
    params: query,
  });
  return res?.data || { items: [], page: 1, limit: 25, total: 0 };
}

export async function getCustomerPortalInstallation(id) {
  const res = await api.get(`/customer-portal/installations/${id}`);
  return res?.data || { item: null };
}

export async function getCustomerPortalSuppliers(query = {}) {
  const res = await api.get("/customer-portal/suppliers", {
    params: query,
  });
  return res?.data || { items: [], page: 1, limit: 25, total: 0 };
}

export async function createCustomerPortalSupplier(payload = {}) {
  const res = await api.post("/customer-portal/suppliers", payload);
  return res?.data || { item: null };
}

export async function updateCustomerPortalSupplier(id, payload = {}) {
  const res = await api.patch(`/customer-portal/suppliers/${id}`, payload);
  return res?.data || { item: null };
}

export async function getCustomerPortalRequests(query = {}) {
  const res = await api.get("/customer-portal/requests", {
    params: query,
  });
  return res?.data || { items: [], page: 1, limit: 25, total: 0 };
}

export async function getCustomerPortalRequestOptions() {
  const res = await api.get("/customer-portal/request-options");
  return res?.data || { locations: [], installations: [], assets: [] };
}

export async function getCustomerPortalRequest(id) {
  const res = await api.get(`/customer-portal/requests/${id}`);
  return res?.data || { item: null, messages: [] };
}

export async function createCustomerPortalRequest(payload = {}) {
  const res = await api.post("/customer-portal/requests", payload);
  return res?.data || { item: null };
}

export async function getCustomerPortalCommunications(query = {}) {
  const res = await api.get("/customer-portal/communications", {
    params: query,
  });
  return res?.data || { items: [], page: 1, limit: 25, total: 0 };
}

export async function getCustomerPortalCommunicationThread(id) {
  const res = await api.get(`/customer-portal/communications/${id}`);
  return res?.data || { thread: null, messages: [] };
}

export async function createCustomerPortalCommunicationReply(id, payload = {}) {
  const res = await api.post(`/customer-portal/communications/${id}/reply`, payload);
  return res?.data || { thread: null, message: null };
}

export { toPortalErrorMessage };
